export default __webpack_public_path__ + "static/studio-2-3-46e6e8811a36e43199d378d4de81f6e1.jpg";